<template>
  <div class="app-component-setting">
    <el-form ref="settingForm" :model="component.data" :rules="component.rules" label-position="top" status-icon :key="component.name">
      <template v-for="(item, key) in component.schema">
        <template v-if="item.type === 'list'">
          <template v-for="(item2, index2) in component.data[key]">
            <div class="app-component-setting__group-name" :key="`group-name-${key}.${index2}`">{{ item.label || '分组' }}{{ index2 + 1 }}</div>
            <template v-for="(item3, key3) in item.fields">
              <component v-if="item.type === 'number'" v-model="item2[key3]" :min="item3.min" :max="item3.max" :step="item3.step" :field="`${key}.${index2}.${key3}`" :label="item3.label" :tip="item3.tip" :rules="item3.rules" :is="`app-type-${item3.type}`" :key="`${key}.${index2}.${key3}`"></component>
              <component v-else-if="item.type === 'checkbox'" v-model="item2[key3]" :options="item3.options" :field="`${key}.${index2}.${key3}`" :label="item3.label" :tip="item3.tip" :rules="item3.rules" :is="`app-type-${item3.type}`" :key="`${key}.${index2}.${key3}`"></component>
              <component v-else-if="item.type === 'textarea'" v-model="item2[key3]" :rows="item3.rows" :field="`${key}.${index2}.${key3}`" :label="item3.label" :tip="item3.tip" :rules="item3.rules" :placeholder="item3.placeholder" :is="`app-type-${item3.type}`" :key="`${key}.${index2}.${key3}`"></component>
              <component v-else v-model="item2[key3]" :field="`${key}.${index2}.${key3}`" :label="item3.label" :tip="item3.tip" :rules="item3.rules" :placeholder="item3.placeholder" :disabled="item3.disabled" :is="`app-type-${item3.type}`" :key="`${key}.${index2}.${key3}`"></component>
            </template>
          </template>
          <div class="app-component-setting__add" v-if="item.canAddAndRemove" :key="`${key}-add-remove`">
            <el-button type="default" size="mini" @click="handleRemoveItem(key, component)">删减</el-button>
            <el-button type="default" size="mini" @click="handleAddItem(key, component)">添加</el-button>
          </div>
        </template>
        <template v-else>
          <component v-if="item.type === 'number'" v-model="component.data[key]" :min="item.min" :max="item.max" :step="item.step" :field="key" :label="item.label" :tip="item.tip" :is="`app-type-${item.type}`" :key="key"></component>
          <component v-else-if="item.type === 'checkbox'" v-model="component.data[key]" :options="item.options" :field="key" :label="item.label" :tip="item.tip" :is="`app-type-${item.type}`" :key="key"></component>
          <component v-else-if="item.type === 'textarea'" v-model="component.data[key]" :rows="item.rows" :field="key" :label="item.label" :tip="item.tip" :placeholder="item.placeholder" :is="`app-type-${item.type}`" :key="key"></component>
          <component v-else v-model="component.data[key]" :field="key" :label="item.label" :tip="item.tip" :placeholder="item.placeholder" :disabled="item.disabled" :is="`app-type-${item.type}`" :key="key"></component>
        </template>
      </template>
      <el-form-item size="small">
        <div class="app-component-setting__btn-group">
          <el-button type="default" @click="resetForm('settingForm')">重 置</el-button>
          <el-button type="primary" @click="submitForm('settingForm')">保 存</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import property from '@/components/property'

export default {
  name: 'app-component-setting',
  components: {
    ...property
  },
  props: {
    component: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      form: {}
    }
  },

  watch: {
    component (value) {
      this.form = value.data
    }
  },

  methods: {
    handleRemoveItem (field, component) {
      component.data[field].pop()
    },

    handleAddItem (field, component) {
      component.data[field].push(component.schema[field].getEmptyItem())
    },

    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$emit('save')
        } else {
          return false
        }
      })
    },

    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.$emit('reset')
    }
  }
}
</script>

<style lang="scss">
.app-component-setting {
  .el-form-item--small .el-form-item__label {
    line-height: 1.2;
  }

  .el-form-item.is-required .el-form-item__label:before {
    font-family: sans-serif;
  }

  .el-checkbox {
    margin-left: 0;
    margin-right: 15px;
  }

  .form-item__tip {
    color: #999;
    font-size: 12px;
    font-family: sans-serif;
  }

  &__group-name {
    padding: 10px 0;
    border-top: 1px solid #eee;
    font-weight: 700;
  }

  &__add {
    padding: 10px;
    border-top: 1px solid #eee;
  }

  &__btn-group {
    display: flex;
    justify-content: space-between;
    padding-top: 30px;

    .el-button {
      width: 48%;
    }
  }
}
</style>
